import React from 'react';
import { Helmet } from 'react-helmet';
import { urlFromName, shortenName } from 'shared/models/city';

export default function ProductHeadTags(cityModel) {
  const city = cityModel.name.name;
  const pageTitle = `${city} Alcohol Delivery - Free Delivery In 30 Minutes | Saucey`;
  // const metaTitle = `Alcohol Delivery ${
  //   cityModel.name.zone == 7 ? shortenName(cityModel.name) : city
  // } - Free Delivery In 30 Minutes | Saucey`;
  const metaTitle = `Alcohol Delivery ${city} - Online Delivery Near You | Saucey`;
  const description = `Saucey has the fastest alcohol delivery in ${city}. Order beer, wine & liquor near you with fast & easy delivery within 30 minutes in ${shortenName(
    cityModel.name
  )}.`;
  const url = urlFromName(city);

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="title" content={metaTitle} />
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
    </Helmet>
  );
}
